import {
  ActiveUserImportStatuses,
  type IUserImportSourceType,
  type IUserImportStatus,
  UserImportSourceType,
} from "@monorepo/core";

const ACTIVE_IMPORT_STATUSES = new Set<IUserImportStatus>(
  ActiveUserImportStatuses,
);

export const isActiveImportStatus = (status?: IUserImportStatus) =>
  Boolean(status && ACTIVE_IMPORT_STATUSES.has(status));

export const formatCardImportTimestamp = (
  value?: string,
  options?: {
    longMonthDay?: boolean;
  },
) => {
  if (!value) return "N/A";

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  const currentYear = new Date().getFullYear();

  return parsed.toLocaleString(undefined, {
    ...(parsed.getFullYear() === currentYear ? {} : { year: "2-digit" }),
    month: options?.longMonthDay ? "long" : "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

export const formatCardImportBytes = (bytes?: number) => {
  if (!bytes || bytes <= 0) {
    return "N/A";
  }

  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const getCardImportSourceLabel = (state: {
  sourceType?: IUserImportSourceType;
  fileName?: string;
  sourceUrl?: string;
}) => {
  if (state.sourceType === UserImportSourceType.UPLOAD) {
    return state.fileName ?? "Uploaded CSV";
  }

  if (state.sourceType === UserImportSourceType.URL) {
    return state.sourceUrl ?? "Legacy URL import";
  }

  return "N/A";
};
